<template>
    <div>
        <div class="campaign-adset-product">
            <div class="campaign-adset-product__title">
                <slot name="product-title"></slot>
            </div>
            <div class="campaign-adset-product__points">
                <label v-for="point in dimensionPoints">
                    <input type="checkbox" :value="point" v-model="productPoints" @change="setPoint($event.target)"> {{ capitalize(point) }} Point{{ point != 1 ? 's' : '' }}
                </label>
            </div>
            <div class="campaign-adset-product__close">
                <a @click.prevent="$emit('close')"><i class="fa fa-times" aria-hidden="true"></i></a>
            </div>
        </div>
        <div class="clearfix"></div>
        <slot></slot>
    </div>
</template>
<style>

</style>
<script>
    export default {
        props: {
            pointChoices: {
                type: Array,
                required: true
            },
            points: {
                type: Array,
                default: []
            }
        },

        data() {
            return {
                dimensionPoints: this.pointChoices,
                productPoints: this.points.sort(),
                allValue: "all"
            };
        },

        methods: {
            capitalize(value) {
                return _.capitalize(value);
            },

            setPoint(pointInput) {
                if (pointInput.value == this.allValue && pointInput.checked) {
                    this.setProductPointsToAll();
                }

                if (pointInput.value == this.allValue && !pointInput.checked) {
                    this.productPoints = [];
                }

                if (pointInput.checked && this.allPointsAreChecked()) {
                    this.setProductPointsToAll();
                } else {
                    this.productPoints = this.withoutAllValue(this.productPoints);
                }

                this.productPoints.sort();

                this.$emit('input', this.productPoints);
            },

            setProductPointsToAll() {
                this.productPoints = Array.from(this.dimensionPoints);
            },

            allPointsAreChecked() {
                return 0 === _.difference(this.everyPointValue(), this.productPoints).length;
            },

            everyPointValue() {
                return this.withoutAllValue(this.dimensionPoints);
            },

            withoutAllValue(points) {
                return _.without(points, this.allValue);
            }
        }
    }
</script>
